/**
 * Konfiguracja URL-i pomocy dla różnych środowisk
 * Automatycznie dostosowuje się do środowiska na podstawie zmiennych środowiskowych
 * Wykorzystuje centralną konfigurację z environment.ts
 */

// Temporary base URL - this should be moved to environment.ts in the future
const HELP_BASE_URL = "https://carbowaste.carbomath.com";
//Jak rozpocząć pracę z bezpłatną wersją dodatku?
export const HelpUrl_how_to_start_free = `${HELP_BASE_URL}/carbowaste-bdo#how-to-start-free`; 
//Jak przejść na pełną wersję dodatku?
export const HelpUrl_how_to_subscribe = `${HELP_BASE_URL}/carbowaste-bdo#how-to-subscribe`; 
//Jak rozpocząć pracę z pełną wersją dodatku?
export const HelpUrl_how_to_start_paid = `${HELP_BASE_URL}/carbowaste-bdo#how-to-start-paid`; 
//Wymagane dane uwierzytelniające BDO
export const HelpUrl_bdo_credentials = `${HELP_BASE_URL}/carbowaste-bdo#bdo-credentials`; 

//kpo_status_overview
export const HelpUrl_kpo_status_overview = `${HELP_BASE_URL}/carbowaste-bdo#kpo-status-overview`;
//kpo_confirmed
export const HelpUrl_kpo_confirmed = `${HELP_BASE_URL}/carbowaste-bdo#confirmed-kpo`;
//keo_monthly_statement
export const HelpUrl_keo_monthly_statement = `${HELP_BASE_URL}/carbowaste-bdo#waste-monthly-statement`;
//keo_annualy
export const HelpUrl_keo_annualy = `${HELP_BASE_URL}/carbowaste-bdo#annual-keo`;
//kpo_card_print
export const HelpUrl_kpo_card_print = `${HELP_BASE_URL}/carbowaste-bdo#kpo-view`;
//keo_card_print
export const HelpUrl_keo_card_print = `${HELP_BASE_URL}/carbowaste-bdo#keo-view`;
//keo_annual_report_with_permit
export const HelpUrl_keo_annual_report_with_permit = `${HELP_BASE_URL}/carbowaste-bdo#waste-annual-statement`;
//dictionaries_wastecode
export const HelpUrl_dictionaries_wastecode = `${HELP_BASE_URL}/waste-codes`;
//dictionaries_wasteprocess
export const HelpUrl_dictionaries_wasteprocess = `${HELP_BASE_URL}/waste-processes`;

//Privacy
export const HelpUrl_privacy = `${HELP_BASE_URL}/privacy`;
//TermsOfUse
export const HelpUrl_terms_of_use = `https://learn.microsoft.com/en-gb/legal/marketplace/standard-contract`;
